import { LkmOrdersPage, LkmRegistration } from 'pages'
import { redirect, RouteObject } from 'react-router-dom'

import { ProtectedRoute } from '../ProtectedRoute'
import { PublicRoute } from '../PublicRoute'

import { commonRoutes } from './commonRoutes'
import { LkmProductTypesPage } from 'pages/LkmProductTypesPage'
import { LkmRegionPage } from 'pages/LkmRegionPage'
import { LkmDocumentsPage } from 'pages/LkmDocumentsPage/LkmDocumentsPage'
import { LkmOrderDetailPage } from 'pages/LkmOrderDetailPage'
import { LkmProfileEditPage } from 'pages/LkmProfileEditPage'

export const lkmRoutes: RouteObject[] = [
  {
    element: <PublicRoute />,
    children: [
      {
        id: 'main',
        index: true,
        loader: () => redirect('/orders'),
      },
      {
        id: 'registration',
        path: '/registration',
        element: <LkmRegistration />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        id: 'orders',
        path: '/orders',
        element: <LkmOrdersPage />,
      },
      {
        id: 'lkm-order',
        path: '/orders/:id',
        element: <LkmOrderDetailPage />,
      },
      {
        id: 'productTypes',
        path: '/product-types',
        element: <LkmProductTypesPage />,
      },
      {
        id: 'regions',
        path: '/regions',
        element: <LkmRegionPage />,
      },
      {
        id: 'documents',
        path: '/documents',
        element: <LkmDocumentsPage />,
      },
      {
        id: 'update-profile',
        path: '/settings/fitter',
        element: <LkmProfileEditPage />,
      },
    ],
  },
  ...commonRoutes,
]
